import React from 'react';
import Dropzone from 'react-dropzone'
import axios from 'axios';
import {Dropdown, Button, Input, Segment, Header, Icon, Container, Grid, Divider, Message } from 'semantic-ui-react';
import { config,
      cloudinaryApi,
      getTimestamp,
       getSignature
     } from '../../apis/cloudinary';
  
  const options = [
    { key: 'p', text: 'Patios', value: 'Patios' },
    { key: 'w', text: 'Walls', value: 'Walls' },
    { key: 'a', text: 'Walkways', value: 'Walkways' }
  ];

  const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    padding: 4,
    boxSizing: 'border-box'
  };
  
  const thumbInner = {
    display: 'flex',
    minWidth: 0,
    width: '100%',
    height: '100%',
    overflow: 'hidden'
  };
  
  const img = {
    display: 'block',
    width: 'auto',
    height: '100%'
  };
  

class UploadField extends React.Component {
    state = {
        files: [],
        category: 'Patios',
        description: '',
        messageHidden: true,
        errorMessage: ''
    };  
    
    sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

    uploadPictures = () => {
        // uploads is an array that would hold all the post methods for each image to be uploaded, then we'd use axios.all()
        const { category, description } = this.state;
        const uploads = this.state.files.map(picture => {
        const timestamp = getTimestamp();
          const formData = new FormData();
          formData.append("file", picture.file);
          formData.append("folder", config.folder);
          formData.append("tags", [...config.tags, category]); // Add tags for the images - {Array}
          formData.append("api_key", config.apiKey); // Replace API key with your own Cloudinary API key
          formData.append("context", `alt=${description}`);
          formData.append("timestamp", timestamp);
          formData.append('signature', 
          getSignature(`context=alt=${description}&folder=${config.folder}&tags=${config.tags.toString()},${category}`, timestamp));

          // Replace cloudinary upload URL with yours
          return cloudinaryApi.post(
            '/image/upload', formData, {  
                headers: { "X-Requested-With": "XMLHttpRequest" },
            }
            ).then(response => {
                
            })
        });
        
        // We would use axios '.all()' method to perform concurrent image upload to cloudinary.
        axios.all(uploads).then(() => {
          // ... do anything after successful upload. You can setState() or save the data
          this.setState({messageHidden: false});
          this.sleep(10000).then(() => this.setState({messageHidden: true}));
          this.cleanupPicutures();
        }).catch((error) => {
            this.setState({messageHidden: false, errorMessage: error});
            this.sleep(10000).then(() => this.setState({messageHidden: true}));
          });
      }
    
    componentWillUnmount() {
        this.cleanupPicutures();
    }

    cleanupPicutures = () => {
        // Cleanup files in memory
        this.state.files.forEach(file => URL.revokeObjectURL(file.preview));
        this.setState({files: []});
    }

    handleOnDrop = (acceptedFiles) => {         
        this.setState({ 
            files: acceptedFiles.map(file => {
                return { preview: URL.createObjectURL(file), file: file }
            })
        });
    }
    componentWillMount() {
        if(process.env.NODE_ENV === 'development' && !options.find(item => item.key === 't')) 
            options.push({ key: 't', text: 'Test', value: 'Test' });
    }

    render() {
        const { files, category } = this.state;
        const thumbs = files.map(file => (
            <div style={thumb} key={file.file.name}>
                <div style={thumbInner}>
                <img
                    src={file.preview}
                    style={img}
                    alt="Preview"
                />
                </div>
            </div>
        ));

        if (thumbs && thumbs.length > 0) {
            return(
                <Container>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={4}>
                                <Dropdown 
                                    options={options} 
                                    placeholder="Select Category"
                                    selection
                                    onChange={(e, field) => this.setState({category: field.value})}
                                    value={category}
                                />
                            </Grid.Column>
                            <Grid.Column width={12}>
                                <Button primary onClick={this.uploadPictures}>Upload</Button>
                                <Button onClick={this.cleanupPicutures}>Cancel</Button>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={14}>
                                <Input fluid
                                    placeholder="Enter Description" 
                                    value={this.state.description}
                                    onChange={(e, field) => this.setState({ description: field.value})}
                                />
                                <i>Note: It may take up to a minute for the image to display in listing</i>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    <Divider />
                    <div>
                        {thumbs}
                    </div>
                </Container>
            );
        } else {
            return (
                <React.Fragment>
                    <Message 
                        success
                        hidden={this.state.messageHidden}
                        header="Picture Has Been Sucessfully Uploaded"
                        content="It may take a few minutes for the picture to actually appear in the administration sire and website"
                    />
                    <Message 
                        error
                        hidden={this.state.errorMessageHidden}
                        header="There was a Problem Deleting the Pictures"
                        content= { `Please try again later, but if it keeps happening contact your administrator.  The Error is: "${this.state.errorMessage}"`}
                    />
                    <Dropzone
                        onDrop={ this.handleOnDrop }
                        accept="image/*"
                        multiple={false}
                    >
                    {({getRootProps, getInputProps}) => (
                        <div {...getRootProps()}>
                            <Segment placeholder>
                                <Header as="h2" icon>
                                    <Icon name="image file outline" />
                                        Drag and Drop Image or Click to Select
                                </Header>
                                <input {...getInputProps()} /> 
                            </Segment>
                        </div>  
                    )}
                    </Dropzone>
                </React.Fragment>
            );
        }
    }
}

export default UploadField;
